import axios from "axios";

class DetectGlossary {
    constructor() {
        this.wordsContainer = document.querySelector(".detectGlossaryJs");
        this.detectedAnchors = this.wordsContainer
            ? this.wordsContainer.querySelectorAll("a")
            : "";
        this.glossaryWords = this.detectGlossaryWords();
        this.getGlossaryContent();
        this.events();

    }

    events() {}

    detectGlossaryWords() {
        if (this.wordsContainer) {
            const glossaryWords = {};
            this.detectedAnchors.forEach((el, index) => {
                if (el.href.includes("glossary")) {
                    glossaryWords["glossary_" + index] = el.href.substring(
                        el.href.lastIndexOf("/") + 1
                    );
                    el.classList.add("glossary-word");
                    el.id = "glossary_" + index;
                }
            });
            return glossaryWords;
        }
    }

    getGlossaryContent() {
        const data = new FormData();

        data.append("action", "getGlossaryContent");
        data.append("words", JSON.stringify(this.glossaryWords));

        axios
            .post(ajax.ajax_url, data)
            .then((res) => {
                const templates = JSON.parse(res.data.data);
                const detectedAnchors =
                    document.querySelectorAll(".glossary-word");
                detectedAnchors.forEach((element, key) => {
                    if (element.id === "glossary_" + key) {
                        const createdChildElement =
                            document.createElement("div");
                        createdChildElement.classList.add(
                            "glossary-word__popup"
                        );
                        createdChildElement.innerHTML =
                            templates["glossary_" + key];
                        element.appendChild(createdChildElement);
                    }

                    element.addEventListener("click", (e) => {
                        e.preventDefault();
                    });
                });
                this.glossaryWordsReady = document.querySelectorAll(".glossary-word");
                this.closePopupBtns = document.querySelectorAll(".glossary-word__popup-close");
                this.registerShowPopupEvents();
                this.registerClosePopupEvents();
            })
            .catch((err) => {

            });
    }

    registerShowPopupEvents() {
        this.glossaryWordsReady.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                let childEl = e.currentTarget.querySelector(".glossary-word__popup");
                if(!childEl.classList.contains('open')){
                    childEl.classList.add("open");
                }
            });
        });
    }

    registerClosePopupEvents() {
        this.closePopupBtns.forEach((element) => {
            element.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                const parentPopup = e.target.parentElement;
                if(parentPopup.classList.contains("open")){
                   parentPopup.classList.remove("open")
               }
            });
        });
    }
}

export default DetectGlossary;
